import { type Project } from '@consigli/types';
import { type FC } from 'react';

import { type ServiceData } from '@/features/project-services/use-project-services';
import { CardGrid } from '@/layouts/card-grid';

import { ServiceCard } from './service-card';

interface ServiceCardGridProps {
  services: ServiceData[];
  projectId: Project['id'];
}

/**
 * One row of service cards.
 *
 * Extracted when the redesigned Agents tab briefly showed these same cards; one
 * consumer again now the tab has its own. agent-card.tsx threads the same fields
 * to the same navigation hook, which is where the two are kept honest.
 *
 * Inline it back into service-list-page.tsx at flag removal.
 */
export const ServiceCardGrid: FC<ServiceCardGridProps> = ({ services, projectId }) => (
  <CardGrid>
    {services.map((service) => (
      <ServiceCard
        active={service.active}
        externalToSolutionViewer={service.externalToSolutionViewer}
        externalUrl={service.externalUrl}
        icon={service.icon}
        id={service.serviceName}
        isBeta={service.isBeta}
        key={service.serviceName}
        newServiceRoute={service.newServiceRoute}
        openInSameWindow={service.openInSameWindow}
        projectId={projectId}
        serviceId={service.serviceId}
        serviceRoute={service.serviceRoute}
        title={service.title}
        tooltip={service.tooltip}
      />
    ))}
  </CardGrid>
);
